/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function RequirementsTagging({
  getRequirementList, requirementList,
  getPermitTypeList, permitTypeList,
  updateApplicationRequirements,
}) {
  const [requirementListFormat, setRequirementListFormat] = useState([]);
  const [permitTypeListFormat, setPermitTypeListFormat] = useState([]);
  const [mode, setMode] = useState(0);
  const [formData, setFormData] = useState([]);
  const updateData = () => {
    getRequirementList({ display_all: 1 });
    getPermitTypeList();
  };
  const formatFormData = () => {
    if (!_.isEmpty(permitTypeList)) {
      const list = permitTypeList.map(x => ({
        id: x.id,
        type: _.get(x, 'attributes.name', ''),
        requirement_list: _.get(x, 'included.applicationStatusRequirements', []).map(item => (item.attributes.requirement_id)),
      }));
      setPermitTypeListFormat(list);
      setFormData(list);
    }
  };

  // TEMPORARY FIX FOR MINOR BUG
  const handleSetMode = (num) => {
    setMode(num);
  };

  const handleToggle = (permitId, reqId) => () => {
    handleSetMode(1);
    const item = formData.find(x => (+x.id === +permitId)); // GET TARGET ROW
    const status = item.requirement_list.filter(x => (+x === +reqId)); // CHECK IF REQ VALUE EXIST IN ROW

    const valueAction = () => { // REMOVE OR ADD REQ_ID IN TARGET
      if (_.isEmpty(status)) {
        const a = _.concat(_.get(item, 'requirement_list', []), +reqId);
        return a;
      }
      const a = item.requirement_list.filter(x => (x !== +reqId));
      return a;
    };

    const newItem = { // REFORMAT TARGET WITH NEW VALUE
      ...item,
      requirement_list: valueAction(),
    };

    const reducedFormData = formData.filter(x => (+x.id !== +newItem.id)); // REMOVE TARGET FROM FORMDATA
    const newFormData = _.concat(reducedFormData, newItem); // REBIULD FORMDATA
    setFormData(newFormData);
  };

  const renderCheckbox = (permitId, reqId) => {
    const item = formData.find(x => (+x.id === +permitId));
    const status = item.requirement_list.filter(x => (+x === +reqId));
    return (
      <button type="button" className="btn-blank" onClick={handleToggle(permitId, reqId)}>
        {_.isEmpty(status)
          ? (<i className="far fa-square icon-check-box cms-text-primary" />)
          : (<i className="fas fa-check-square icon-box cms-text-primary" />)}
      </button>
    );
  };

  const handleSubmit = () => {
    handleSetMode(0);
    const args = formData.map(item => ({ application_status_id: item.id, requirement_id: item.requirement_list }));
    args.map(item => updateApplicationRequirements(item));
  };

  const handleCancel = () => {
    setFormData(permitTypeListFormat);
    handleSetMode(0);
  };

  useEffect(() => {
    updateData();
  }, []);

  useEffect(() => {
    formatFormData();
  }, [permitTypeList]);

  useEffect(() => {
    if (!_.isEmpty(requirementList)) {
      const list = requirementList.map(x => ({
        requirement_id: _.get(x, 'id', ''),
        requirement_name: _.get(x, 'attributes.name'),
      }));
      setRequirementListFormat(list);
    }
  }, [requirementList]);

  // console.log('permitTypeListFormat: ', permitTypeListFormat);
  return (
    <div className="card p-0 card-requirements-tagging">
      <div className="">
        <div className="container-fluid p-4">
          <div className="row d-flex align-items-center px-3">
            <div className="col-6">
              <h2 className="font-weight-bold">Requirements Tagging</h2>
            </div>
            <div className="col-6 d-flex">
              {mode === 1 ? (
                <React.Fragment>
                  <button
                    type="button"
                    className="btn btn-dark font-weight-bold ml-auto mr-2"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </React.Fragment>
              ) : ''
              }
            </div>
            <hr className="w-100" />
          </div>
          {/* TABLE */}
          <div className="table-responsive mt-4">
            <table className="table table-borderless">
              <thead>
                <tr className="cms-bg-color-primary-light cms-text-primary">
                  {!_.isEmpty(permitTypeListFormat)
                    ? (
                      <React.Fragment>
                        <th scope="col" className="px-1">Requirement Types</th>
                        {permitTypeListFormat.map(item => (
                          <th scope="col" className="px-1" key={item.id}><div className="w-100 text-center">{item.type || ''}</div></th>
                        ))}
                      </React.Fragment>
                    ) : <th scope="col">Requirement Types</th>}
                </tr>
              </thead>
              <tbody>
                {!_.isEmpty(requirementListFormat)
                  ? (
                    <React.Fragment>
                      {requirementListFormat.map(item => (
                        <tr className="top-border" key={item.requirement_id}>
                          <td className="font-weight-bold cms-text-muted-secondary py-3">{item.requirement_name}</td>
                          {permitTypeListFormat.map(x => (
                            <td className="py-3" key={x.id}><div className="w-100 text-center">{renderCheckbox(x.id, item.requirement_id)}</div></td>
                          ))}
                        </tr>
                      ))}
                    </React.Fragment>
                  ) : <tr />}
              </tbody>
            </table>
          </div>

          {/* <div className="row mt-3 mb-5">
            <div className="col">
              <div className="card d-flex align-content-center">
                <h4 className="mb-4 mt-3 text-center w-100">NEW</h4>
                {permitTypeListFormat.map(item => (
                  <div key={item.id} className="card mb-2">
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-11">
                          {item.label}
                        </div>
                        <div className="col-1">
                          <input type="checkbox" />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

RequirementsTagging.propTypes = {
  getPermitTypeList: PropTypes.instanceOf(Function).isRequired,
  permitTypeList: PropTypes.instanceOf(Array).isRequired,

  getRequirementList: PropTypes.instanceOf(Function).isRequired,
  requirementList: PropTypes.instanceOf(Array).isRequired,

  updateApplicationRequirements: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permitTypeList: _.get(api, `${c.GET_PERMIT_TYPE_LIST}.list`) || [],
  requirementList: _.get(api, `${c.GET_REQUIREMENT_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);

export default enhance(RequirementsTagging);
